export default __webpack_public_path__ + "static/toolsImage2-97ebdbb0e58f9ae211bca999bc5dbaaf.webp";